import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavbarProps } from './types';
import Icon from '../Icon';
import './index.less';
import { isInApp } from '@root/shared';

const Navbar = ({
  children,
  title,
  className = '',
  onBack,
  ...rest
}: NavbarProps) => {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  }, [navigate, onBack]);

  if (isInApp) {
    return null;
  }

  return (
    <div className={`navbar ${className}`} {...rest}>
      <div className="back" onClick={handleBack}>
        <Icon type="arrow-left" />
      </div>
      <div className="title">{title}</div>
      <div className="right">{children}</div>
    </div>
  );
};

export default Navbar;
